/**
 * App-level state: online status, install prompt, active view.
 */

import { create } from 'zustand';

export type ViewId = 'today' | 'calendar' | 'tasks' | 'notes' | 'settings' | 'download';

interface AppState {
  isOnline: boolean;
  activeView: ViewId;
  deferredInstallPrompt: BeforeInstallPromptEvent | null;

  setOnline: (online: boolean) => void;
  setActiveView: (view: ViewId) => void;
  setInstallPrompt: (e: BeforeInstallPromptEvent | null) => void;
}

export const useAppStore = create<AppState>((set) => ({
  isOnline: navigator.onLine,
  activeView: 'today',
  deferredInstallPrompt: null,

  setOnline: (online) => set({ isOnline: online }),
  setActiveView: (view) => set({ activeView: view }),
  setInstallPrompt: (e) => set({ deferredInstallPrompt: e }),
}));

// beforeinstallprompt is not in standard TS lib
export interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}
